<tt-card ttClass="flex-column height-full flex-1">
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="docpacktypechapter_keyno" [ttModel]="edit.docpacktypechapter_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="docpacktypechapter_name" [(ttModel)]="edit.docpacktypechapter_name" ttRequired></tt-input>
        <tt-input-number ttLabel="docpacktypechapter_order" [(ttModel)]="edit.docpacktypechapter_order" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-editor class="flex-1" ttLabel="html_text" [(ttModel)]="edit.html_text" ttHeight="100%"></tt-editor>
        <tt-button-save ttText="docpacktypechapter_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button
            *ngIf="'' + edit.docpacktypechapter_keyno !== '0'"
            ttText="docpacktypechapter_delete"
            (ttClick)="deleteValues()"
            ttIcon="fas fa-trash-alt"
            ttType="danger"
            [ttLoading]="deleting"
        ></tt-button>
    </ng-container>

    <ng-container *ngIf="!edit">
        <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
        <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
        <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
        <div class="col-xs-12 sp-0 tt-skeleton flex-1" style="height: 20rem; margin-bottom: 7px"></div>
        <div class="col-xs-12 sp-0">
            <div class="tt-skeleton" style="height: var(--tt-height); background-color: var(--tt-success-color); margin-bottom: 7px"></div>
        </div>
    </ng-container>
</tt-card>

<ng-template #inputskeleton>
    <div class="col-xs-4 sp-0 tt-skeleton" style="width: 40%; height: var(--tt-font-size-sm); margin-bottom: 4px"></div>
    <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="docpacktypechapter_keyno" tt-model="vm.model.edit.docpacktypechapter_keyno" tt-change="vm.model.edit.docpacktypechapter_keyno = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="docpacktypechapter_name" tt-model="vm.model.edit.docpacktypechapter_name" tt-change="vm.model.edit.docpacktypechapter_name = $value" tt-readonly="false" tt-required="true"></tt-input>
        <tt-input-number class="col-xs-12 sp-0" tt-label="docpacktypechapter_order" tt-model="vm.model.edit.docpacktypechapter_order" tt-change="vm.model.edit.docpacktypechapter_order = $value" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 0 }" tt-readonly="false"></tt-input-number>
        <tt-text-editor tt-label="html_text_template" tt-model="vm.model.edit.html_text" tt-change="vm.model.edit.html_text = $value" tt-readonly="false" tt-ready="vm.model.edit.readyHtmlText"></tt-text-editor>
        <tt-button-save class="col-xs-12 sp-0" tt-text="docpacktypechapter_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>

        <div ng-if="vm.model.docPackTypeChapterKeyno > 0">
            <tt-button class="col-xs-12 sp-0" tt-text="docpacktypechapter_delete" tt-locked="vm.model.lockedDelete" tt-click="vm.deleteValues()" tt-icon="fas fa-trash-alt" tt-type="danger" tt-text-align="center"></tt-button>
        </div>
    </tt-card>
</tt-page>-->
